import { useQuery } from "@tanstack/react-query";
import { customInstance } from "../../api/custom-instance";

interface MoleculeHighlightingParams {
    resultsetId: number;
    modelHash?: string | null;
    moleculeIndex?: number | null;
    methodFilter?: string | null;
}

export interface MoleculeHighlightingEntry {
    atom_bond_importance: any[];
    metadata: any;
}

export interface MoleculeHighlightingResponse {
    [modelHash: string]: {
        molecule_highlighting: MoleculeHighlightingEntry[];
    };
}

async function fetchMoleculeHighlighting(params: MoleculeHighlightingParams): Promise<MoleculeHighlightingResponse> {
    const searchParams = new URLSearchParams();
    if (params.modelHash) searchParams.set("model_hash", params.modelHash);
    if (params.moleculeIndex != null) searchParams.set("molecule_index", String(params.moleculeIndex));
    if (params.methodFilter) searchParams.set("method_filter", params.methodFilter);

    const queryString = searchParams.toString();
    const url = `resultset/molecule_highlighting/${params.resultsetId}${queryString ? `?${queryString}` : ""}`;

    return customInstance<MoleculeHighlightingResponse>({ url, method: "GET" }) as unknown as Promise<MoleculeHighlightingResponse>;
}

export function useMoleculeHighlighting(
    params: MoleculeHighlightingParams,
    enabled: boolean = true,
) {
    return useQuery<MoleculeHighlightingResponse>({
        queryKey: ["resultset-molecule-highlighting", params.resultsetId, params.modelHash, params.moleculeIndex, params.methodFilter],
        queryFn: () => fetchMoleculeHighlighting(params),
        enabled: enabled && params.resultsetId > 0,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}

export { fetchMoleculeHighlighting };
